export default (photo, size = '', token) => {
  if (!photo) return '';
  return `${photo[0]}${size}${photo[1]}${token ? `?token=${token}` : ''}`;
};
